import { Input } from '@/client/components/ui/input';
import { Label } from '@/client/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/client/components/ui/select';
import { Textarea } from '@/client/components/ui/textarea';
import { toISODate } from '@/client/lib/dates';

export type EntryForm = {
  project_id: string;
  date: string;
  description: string;
  hours: string;
};

export function emptyEntryForm(): EntryForm {
  return { project_id: '', date: toISODate(new Date()), description: '', hours: '' };
}

interface EntryFormFieldsProps {
  form: EntryForm;
  setForm: React.Dispatch<React.SetStateAction<EntryForm>>;
  projects: Array<{ id: string; name: string }>;
}

export function EntryFormFields({ form, setForm, projects }: EntryFormFieldsProps) {
  return (
    <>
      <div className="space-y-1.5">
        <Label htmlFor="ef-date">Date</Label>
        <Input
          id="ef-date"
          type="date"
          required
          value={form.date}
          onChange={(e) => setForm((f) => ({ ...f, date: e.target.value }))}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="ef-project">Project</Label>
        <Select
          value={form.project_id}
          onValueChange={(v) => setForm((f) => ({ ...f, project_id: v }))}
        >
          <SelectTrigger id="ef-project">
            <SelectValue placeholder="Select project…" />
          </SelectTrigger>
          <SelectContent>
            {projects.map((p) => (
              <SelectItem key={p.id} value={p.id}>
                {p.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="ef-hours">Hours</Label>
        <Input
          id="ef-hours"
          type="number"
          min="0.25"
          max="24"
          step="0.25"
          required
          value={form.hours}
          onChange={(e) => setForm((f) => ({ ...f, hours: e.target.value }))}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="ef-desc">Description</Label>
        <Textarea
          id="ef-desc"
          required
          value={form.description}
          onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
        />
      </div>
    </>
  );
}
